import styled from 'styled-components';

export const ContactForm = styled.div`
  .element-field {
    margin-bottom: 15px;

    .label-title {
      font-weight: 300;
      display: block;
      margin-bottom: 5px;
    }

    .form-control:not([type='radio']) {
      font-family: Muli, sans-serif;
      border: 0;
      outline: none;
      border-bottom: 1px solid #00b0e6;
      background: #f7f7f7;
      font-size: 14px;
      padding: 8px 12px;
      display: block;
      width: 100%;
      &:not(textarea) {
        height: 38px;
      }
      &.form-textarea {
        height: 100px;
        border: 1px solid #00b0e6;
      }
    }

    span {
      color: rgba(255, 0, 0, 0.56);
      font-size: 12px;
    }
  }

  .footer-buttons {
    display: flex;
    justify-content: flex-end;
  }

  .btn {
    height: 46px;
    padding: 0 30px;
    border-radius: 30px;
    text-transform: uppercase;
    white-space: nowrap;
    background: #ffffff;
    border: 1px solid #0063de;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s linear;
    outline: none;
    text-decoration: none;
    color: #0063de;
    max-width: 220px;
    &:hover {
      background-color: rgba(0, 176, 230, 0.25);
      color: #0063de;
    }
  }
`;
